import { render, staticRenderFns } from "./LandSize.vue?vue&type=template&id=714bd40a&"
import script from "./LandSize.vue?vue&type=script&lang=js&"
export * from "./LandSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports